import React from 'react';

const Devider = ({}) => {
	return (
		<hr className='devider' />
  )
};

export default Devider;